import React, { useState } from "react";
import "../styles/VideoSlider.css";

const VideoSlider = () => {
  // Définir l'index initial au milieu
  const [currentIndex, setCurrentIndex] = useState(1);

  const videos = [
    { src: "/assets/videos/Baltee_France3.mp4", title: "France 3" },
    { src: "/assets/videos/Baltee_BFM.mp4", title: "BFM Business" },
    { src: "/assets/videos/Baltee_Europe1.mp4", title: "Europe 1" },
  ];

  // Gestion du swipe tactile
  let startX = 0;

  const handleTouchStart = (e) => {
    startX = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    if (startX - endX > 50) {
      // Swipe à gauche → vidéo suivante
      setCurrentIndex((prevIndex) => (prevIndex + 1) % videos.length);
    } else if (endX - startX > 50) {
      // Swipe à droite → vidéo précédente
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? videos.length - 1 : prevIndex - 1
      );
    }
  };

  return (
    <div
      className="video-slider"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div className="video-stack">
        {videos.map((video, index) => (
          <div
            key={index}
            className={`video-card ${
              index === currentIndex
                ? "active"
                : index < currentIndex
                ? "prev"
                : "next"
            }`}
          >
            <video src={video.src} controls loop muted className="video-element"></video>
          </div>
        ))}
      </div>
      {/* <div className="video-dots">
        {videos.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentIndex === index ? "active-dot" : ""}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div> */}
    </div>
  );
};

export default VideoSlider;
